import { createContext } from 'react';
import type { PLDSaveStepsType } from './types';

const PLDSaveSteps = createContext<PLDSaveStepsType>({} as PLDSaveStepsType);

export default PLDSaveSteps;
